import { Create, SimpleForm, TextInput } from "react-admin";

const CreatePullApartMapping = (props) => {
  return (
    <Create {...props} redirect="list">
      <SimpleForm>
        <TextInput label="SQR Make" source="sqrMake" fullWidth required />
        <TextInput label="SQR Model" source="sqrModel" fullWidth required />
        <TextInput
          label="Pull-A-Part Make"
          source="papMake"
          fullWidth
          required
        />
        <TextInput
          label="Pull-A-Part Model"
          source="papModel"
          fullWidth
          required
        />
      </SimpleForm>
    </Create>
  );
};

export default CreatePullApartMapping;
